import DefaultDetail from "@Common/DefaultDetail";
import { inject, observer } from "mobx-react";

import "./style.scss";
import { getEditInputsByStep } from "../../../config.jsx";

const Real = inject("mainStore")(
    observer(({ mainStore, setStep, step, countOfSteps }) => {
        const detailData = mainStore.getMainStore("detailData");
        const input = getEditInputsByStep({ mainStore, detailData, isAdd: true }).step4 || [];

        return <DefaultDetail apiUrl={"/promo/offers"} inputs={input} page={"offers"} setStep={setStep} step={step} countOfSteps={countOfSteps} />;
    }),
);

export default Real;
